document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dyo--carousel .dyo-track-wrap').forEach((wrap) => {
    const track = wrap.querySelector('.dyo-track');
    const prev = wrap.querySelector('.dyo-arrow--prev');
    const next = wrap.querySelector('.dyo-arrow--next');
    if (!track || !prev || !next) return;

    const scrollAmount = () => track.clientWidth * 0.85;
    prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  });
});